var map = {
	"./1/Cardiologia.vue": [
		"59b1",
		"chunk-0a7be5b4"
	],
	"./1/Laboratorio.vue": [
		"6dc5",
		"chunk-4d4c7be7"
	],
	"./1/Pediatria.vue": [
		"8e23",
		"chunk-8b8903ce"
	],
	"./195/Cardiologia.vue": [
		"1e13",
		"chunk-777639d1"
	],
	"./195/Laboratorio.vue": [
		"aa7e",
		"chunk-377e0919"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "87cd";
module.exports = webpackAsyncContext;